import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import i18n from '../i18n'

import { db } from "@/db";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            id: null,
            uid: null,
            name: null,
            surname: null,
            email: null,
            badge: null,
            partecipants: [],
            docs: []
        },
        auth: false,        
        token: null,
        error: null
    },
    plugins: [createPersistedState({ key: 'segrate' })],
    mutations: {
        SET_USER(state, { id, uid, name, surname, email, badge, partecipants = [], docs = [] }) {
            state.user.id = id
            state.user.uid = uid
            state.user.name = name
            state.user.surname = surname
            state.user.email = email
            state.user.badge = badge
            state.user.partecipants = partecipants
            docs.map(doc => {
                if (typeof doc.created.toDate === 'function') doc.created = doc.created.toDate()
            })
            state.user.docs = docs
            state.auth = true
        },
        ADD_PARTECIPANT(state, { name, surname, email, school, badge }) {
            state.user.partecipants.push({ name, surname, email, school, badge })
        },
        REMOVE_PARTECIPANT(state, index) {
            state.user.partecipants.splice(index, 1)
        },
        ADD_DOC(state, doc) {
            state.user.docs.push(doc)
        },
        REMOVE_DOC(state, index) {
            state.user.docs.splice(index, 1)
        },
        LOGOUT(state) {
            state.auth = false
        }
    },
    actions: {

    },
    getters: {
        user: (state) => {
            return state.user
        }
    },
    modules: {}
})